<template>
  <h4 v-if="nodes === null">Loading..</h4>
  <div v-else>
    <node-summary :nodes="nodes" v-if="nodes" class="mb-4">
      <!-- header stats -->
    </node-summary>

    <b-card-group deck>
      <b-card v-for="node in nodes" :key="node.id"
        class="d-inline-flex node-card mb-4">
        <template v-slot:header>
          <span class="font-weight-bold">{{ node.host }}</span>
          <b-badge :variant="dcMap[node.datacenter]" class="float-right">
            {{ node.datacenter }}
          </b-badge>
        </template>
        <b-form-group label="Bandwidth (In / Out)">
          <b-row no-gutters>
            <b-col>
              <b-progress max="800">
                <b-progress-bar :variant="variantOf(usage(node.mbps_in, 800))" :value="node.mbps_in" show-progress>
                  {{node.mbps_in }}
                  ({{ usage(node.mbps_in, 500) }}%)
                </b-progress-bar>
              </b-progress>
            </b-col>
            <span class="mx-3">/</span>
            <b-col>
              <b-progress :max="500">
                <b-progress-bar show-progress :variant="variantOf(usage(node.mbps_out, 500))" :value="node.mbps_out">
                  {{ node.mbps_out }}
                  ({{ usage(node.mbps_out, 500) }}%)
                </b-progress-bar>
              </b-progress>
            </b-col>
          </b-row>
        </b-form-group>
        <b-form-group label="CPU">
          {{ node.cpu_count }} Cores, {{ parseInt(node.cpu_load * 100) }}% Load
        </b-form-group>
        <b-form-group label="QPS (In / Out)">
          <b-row no-gutters>
            <b-col>
              {{ node.qps_in }}
            </b-col>
            <span class="mx-3">/</span>
            <b-col>
              {{ node.qps_out }}
            </b-col>
          </b-row>
        </b-form-group>
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
  import { AdminApi } from '../api'
  import NodeSummary from "../components/NodeSummary.vue";

  export default {
    name: 'Nodes',
    created () {
      AdminApi.nodes().then((nodes) => {
        this.nodes = nodes
      })
    },
    data () {
      return {
        nodes: null,
        dcMap: {
          'api': 'secondary',
          'us-east': 'primary',
          'us-west': 'info',
          'europe': 'warning',
          'apac': 'danger'
        }
      }
    },
    methods: {
      variantOf (percent) {
        console.log(percent)

        if (percent <= 85) {
          return 'success'
        } else if (percent > 85 && percent <= 95) {
          return 'warning'
        } else {
          return 'danger'
        }
      },
      usage (value, max) {
        return Math.round((value / max) * 100)
      }
    },
    components: {
      NodeSummary
    }
  }
</script>

<style>
  .node-card {
    width: 400px;
    min-width: 300px !important;
    max-width: 400px !important;
  }
</style>



// WEBPACK FOOTER //
// src/admin/pages/Nodes.vue